"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.connectComet = exports.equalAddress = exports.simultaneousAsync = exports.getEventAttribute = exports.getAttribute = exports.getEvent = void 0;
const tendermint_rpc_1 = require("@cosmjs/tendermint-rpc");
const getEvent = (events, event) => events.find((ev) => ev.type === event);
exports.getEvent = getEvent;
const getAttribute = (event, attribute) => { var _a; return (_a = event.attributes.find((attr) => attr.key === attribute)) === null || _a === void 0 ? void 0 : _a.value; };
exports.getAttribute = getAttribute;
const getEventAttribute = (events, event, attribute) => {
    const found = (0, exports.getEvent)(events, event);
    return found ? (0, exports.getAttribute)(found, attribute) : undefined;
};
exports.getEventAttribute = getEventAttribute;
const simultaneousAsync = (calls) => __awaiter(void 0, void 0, void 0, function* () {
    const executor = (promise, field) => __awaiter(void 0, void 0, void 0, function* () {
        const result = yield promise();
        return { result, field };
    });
    const response = yield Promise.all(Object.entries(calls).map(([key, value]) => executor(value, key)));
    return response.reduce((acc, cur) => (Object.assign(Object.assign({}, acc), { [cur.field]: cur.result })), {});
});
exports.simultaneousAsync = simultaneousAsync;
const equalAddress = (a, b) => __awaiter(void 0, void 0, void 0, function* () { return a.toLowerCase() === b.toLowerCase(); });
exports.equalAddress = equalAddress;
const connectComet = (endpoint) => __awaiter(void 0, void 0, void 0, function* () {
    let commetClient;
    const tm37Client = yield tendermint_rpc_1.Tendermint37Client.connect(endpoint);
    const version = (yield tm37Client.status()).nodeInfo.version;
    if (version.startsWith('0.37.')) {
        commetClient = tm37Client;
    }
    else {
        tm37Client.disconnect();
        commetClient = yield tendermint_rpc_1.Tendermint34Client.connect(endpoint);
    }
    return commetClient;
});
exports.connectComet = connectComet;
//# sourceMappingURL=cosmos.js.map